// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.
export enum APP_MODES {
  DEMO = 0,
  PROD,
}

export const CURRENT_APP_MODE: APP_MODES = APP_MODES.DEMO;

export const AUDERE_URL = "https://auderenow.org/";
